import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import IUser from "../../types/services/IUser";
import ICharity from "../../types/services/ICharity";

export const loginUser = (
  user: IUser,
  currentCharity: string,
  charities: Array<ICharity>
): IAction => ({
  type: actionTypes.LOGIN_USER,
  meta: {
    user: user,
    currentCharity: currentCharity,
    charities: charities,
  },
});

export const logoutCurrentUser = (remember: boolean): IAction => ({
  type: actionTypes.LOGOUT_USER,
  meta: {
    remember: remember,
  },
});

export const changeCurrentCharity = (charity: ICharity): IAction => ({
  type: actionTypes.CHANGE_CURRENT_CHARITY,
  meta: {
    currentCharity: charity,
  },
});

export const updateCharities = (charities: Array<ICharity>): IAction => ({
  type: actionTypes.UPDATE_CHARITIES,
  meta: {
    charities: charities,
  },
});

export const updateCurrentPhotoUrl = (photoUrl: string): IAction => ({
  type: actionTypes.UPDATE_PHOTO_URL,
  meta: {
    photoUrl: photoUrl,
  },
});

export const updateCurrentProfile = (
  name: string,
  firstName: string,
  lastName: string
): IAction => ({
  type: actionTypes.UPDATE_PROFILE,
  meta: {
    name: name,
    firstName: firstName,
    lastName: lastName,
  },
});

export const rememberUser = (): IAction => ({
  type: actionTypes.REMEMBER_USER,
});
